const formatCurrency = (num: number) => {
  return num.toLocaleString();
};

export { formatCurrency };
